import create from 'zustand'
import { persist } from 'zustand/middleware'
import { CHF_CURRENCY, EUR_CURRENCY, USD_CURRENCY } from '../models/Pricing'
import { key } from '../localization/localization'
import { track } from '../helpers/trackerHelper'
import moment from 'moment'
import firebase from 'firebase/app'

const store = set => ({
  language: key.getLanguage(),
  setLanguage: (language, triggerByUser) => {
    triggerByUser && track('change_language', { language })
    key.setLanguage(language)
    moment.updateLocale(
      language,
      language === 'en'
        ? require(`moment/locale/en-gb.js`)
        : require(`moment/locale/${language}.js`)
    )
    firebase.auth().languageCode = language
    set({ language })
  },
  currency: USD_CURRENCY,
  setCurrency: currency => {
    const c = currency.toUpperCase()
    set({ currency: [EUR_CURRENCY, CHF_CURRENCY].includes(c) ? c : USD_CURRENCY })
  },
})

export const settingsStore = create(persist(store, { name: 'settingsStore' }))
